/* NP 7.9 (4/10): anbefalingernes billeder hentes i 200 px (vises 77 px) i stedet for originalen (op til 1080 px). */
/* NordiskPuls - kurv-skuffens egen logik (upsell, auto-gave, checkout).
   Flyttet ud af snippets/cart-drawer.liquid uden indholdsmaessige
   aendringer. Ingen Liquid heri. */

document.addEventListener('DOMContentLoaded', function () {
let isFetchingUpsell = false;
// NP 7.6: kommer der en kurvaendring, mens anbefalingerne hentes, koeres de igen bagefter
let upsellIgen = false;
let upsellTimeout;
window.isProcessingGift = false;

let currentUpsellRef = null;
let currentCartContent = "";
let cachedUpsellHTML = "";

// Gør sletning øjeblikkelig visuelt!
document.addEventListener('click', function(e) {
const removeBtn = e.target.closest('cart-remove-button, .cart-remove-button-custom');
if (removeBtn) {
const cartItem = removeBtn.closest('.cart-item');
if (cartItem) {
cartItem.style.opacity = '0.3';
cartItem.style.pointerEvents = 'none';
}
}
});

function updateCartDrawerHTML(htmlString) {
const parsedHTML = new DOMParser().parseFromString(htmlString, 'text/html');
const currentInner = document.querySelector('.drawer__inner');
const newInner = parsedHTML.querySelector('.drawer__inner');
if (currentInner && newInner) {
currentInner.innerHTML = newInner.innerHTML;
}

const currentDrawer = document.querySelector('cart-drawer');
const newDrawer = parsedHTML.querySelector('cart-drawer');
if (currentDrawer && newDrawer) {
if (newDrawer.classList.contains('is-empty')) {
currentDrawer.classList.add('is-empty');
} else {
currentDrawer.classList.remove('is-empty');
}
}

const currentDrawerItems = document.querySelector('cart-drawer-items');
const newDrawerItems = parsedHTML.querySelector('cart-drawer-items');
if (currentDrawerItems && newDrawerItems) {
if (newDrawerItems.classList.contains('is-empty')) {
currentDrawerItems.classList.add('is-empty');
} else {
currentDrawerItems.classList.remove('is-empty');
}
}
updateDynamicUpsell();
}

function updateDynamicUpsell() {
if (isFetchingUpsell) { upsellIgen = true; return; }

const items = Array.from(document.querySelectorAll('.cart-item'));
const firstRealItem = items.find(item => !item.hasAttribute('data-is-gift'));
const container = document.getElementById('upsell-container');
const wrapper = document.getElementById('dynamic-upsell-wrapper');

if (!firstRealItem || !container || !wrapper) {
if (wrapper) wrapper.style.display = 'none';
currentUpsellRef = null;
currentCartContent = "";
cachedUpsellHTML = "";
return;
}

const productId = firstRealItem.getAttribute('data-product-id');
const realItems = items.filter(item => !item.hasAttribute('data-is-gift'));
// NP 7.6: gavelinjer taeller med, saa en gave der lander i kurven (fx naesestrips)
// udloeser en ny hentning og ikke bliver ved med at blive anbefalet.
const cartIdsString = items.map(row => row.getAttribute('data-product-id') + (row.hasAttribute('data-is-gift') ? 'g' : '')).sort().join(',');
const needsRestore = (wrapper.style.display === 'none' || container.innerHTML.trim() === '');

if (productId === currentUpsellRef && cartIdsString === currentCartContent) {
if (needsRestore && cachedUpsellHTML !== "") {
container.innerHTML = cachedUpsellHTML;
wrapper.style.display = 'block';
}
return;
}

currentUpsellRef = productId;
currentCartContent = cartIdsString;
isFetchingUpsell = true;

fetch(`${window.Shopify.routes.root}recommendations/products.json?product_id=${productId}&limit=3&intent=related`)
.then(response => response.json())
.then(({ products }) => {
const activeContainer = document.getElementById('upsell-container');
const activeWrapper = document.getElementById('dynamic-upsell-wrapper');
if (!activeContainer || !activeWrapper) return;

const liveItems = Array.from(document.querySelectorAll('.cart-item'));
const currentIds = liveItems.map(row => row.getAttribute('data-product-id'));
const filteredProducts = products.filter(p => !currentIds.includes(p.id.toString()));

if (filteredProducts.length > 0) {
const html = filteredProducts.map(product => `
<div class="upsell-product">
<a href="${product.url}" style="display: block; line-height: 0;">
  <img src="${product.featured_image}${String(product.featured_image).indexOf('?')>-1?'&':'?'}width=200" alt="${product.title}" width="55" height="55" loading="lazy">
</a>
<div class="upsell-details">
<a href="${product.url}" style="text-decoration: none;">
  <p class="upsell-title">${product.title}</p>
</a>
<p class="upsell-price">
  ${product.compare_at_price > product.price 
    ? `<s style="color: #888; font-size: 1.05rem; margin-right: 4px;">${(product.compare_at_price / 100).toLocaleString('da-DK', {style: 'currency', currency: 'DKK', minimumFractionDigits: 0}).replace(',00', '').replace('kr.', 'kr')}</s>` 
    : ''}
  ${(product.price / 100).toLocaleString('da-DK', {style: 'currency', currency: 'DKK', minimumFractionDigits: 0}).replace(',00', '').replace('kr.', 'kr')}
</p>
</div>
<form method="post" action="/cart/add" class="upsell-form">
  ${product.variants.length > 1 
    ? `<select name="id" class="upsell-variant-select">
        ${product.variants.map(v => 
          v.available 
            ? `<option value="${v.id}">${v.title}</option>` 
            : `<option disabled="disabled">${v.title} - Udsolgt</option>`
        ).join('')}
       </select>`
    : `<input type="hidden" name="id" value="${product.variants[0].id}" />`
  }
  <button type="submit" name="add" class="upsell-add-btn">Tilføj</button>
</form>
</div>
`).join('');
activeContainer.innerHTML = html;
activeWrapper.style.display = 'block';
cachedUpsellHTML = html;
} else {
activeWrapper.style.display = 'none';
cachedUpsellHTML = "";
}
})
.catch(e => {
console.error('Fejl i upsell fetch:', e);
const activeWrapper = document.getElementById('dynamic-upsell-wrapper');
if (activeWrapper) activeWrapper.style.display = 'none';
currentUpsellRef = null;
})
.finally(() => {
isFetchingUpsell = false;
if (upsellIgen) { upsellIgen = false; debounceUpsell(); }
});
}

function debounceUpsell() {
clearTimeout(upsellTimeout);
upsellTimeout = setTimeout(updateDynamicUpsell, 150);
}

document.addEventListener('submit', function(e) {
if (e.target.matches('.upsell-form')) {
e.preventDefault();
const form = e.target;
const btn = form.querySelector('.upsell-add-btn');
btn.textContent = 'Tilføjer...';
btn.style.opacity = '0.7';
btn.disabled = true;

const formData = new FormData(form);
formData.append('sections', 'cart-drawer');

fetch(window.Shopify.routes.root + 'cart/add.js', {
method: 'POST',
body: formData
})
.then(res => res.json())
.then(data => {
if (data.sections && data.sections['cart-drawer']) {
updateCartDrawerHTML(data.sections['cart-drawer']);
}
})
.finally(() => {
btn.textContent = 'Tilføj';
btn.style.opacity = '1';
btn.disabled = false;
});
}
});

function checkAutoGift() {
const giftData = document.getElementById('AutoGiftData');
if (!giftData || window.isProcessingGift) return;
const threshold = parseInt(giftData.dataset.threshold);
const cartTotal = parseInt(giftData.dataset.cartTotal);
const hasGift = giftData.dataset.hasGift === 'true';
const variantId = giftData.dataset.variantId;
const lineKey = giftData.dataset.lineKey;

if (cartTotal >= threshold && !hasGift) {
window.isProcessingGift = true;
fetch(window.Shopify.routes.root + 'cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({
items: [{ id: variantId, quantity: 1, properties: { '_is_gift': 'true' } }],
sections: 'cart-drawer'
})
}).then(res => res.json()).then(data => {
if (data.sections && data.sections['cart-drawer']) {
updateCartDrawerHTML(data.sections['cart-drawer']);
}
window.isProcessingGift = false;
});
} else if (cartTotal < threshold && hasGift) {
window.isProcessingGift = true;
fetch(window.Shopify.routes.root + 'cart/change.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({ id: lineKey, quantity: 0, sections: 'cart-drawer' })
}).then(res => res.json()).then(data => {
if (data.sections && data.sections['cart-drawer']) {
updateCartDrawerHTML(data.sections['cart-drawer']);
}
window.isProcessingGift = false;
});
}
}

const drawerNode = document.querySelector('cart-drawer');
if (drawerNode) {
const observer = new MutationObserver((mutations) => {
const isCartUpdate = mutations.some(m => m.addedNodes.length > 0 || m.removedNodes.length > 0);
if (isCartUpdate) {
checkAutoGift();
debounceUpsell();
}
});
observer.observe(drawerNode, { childList: true, subtree: true });
}

document.addEventListener('cart:updated', function() {
checkAutoGift();
updateDynamicUpsell();
});

updateDynamicUpsell();
checkAutoGift();

window.triggerCheckout = function(e) {
const form = document.getElementById('CartDrawer-Form');
const btn = document.getElementById('CartDrawer-Checkout');

if (btn) {
btn.innerHTML = '<span class="checkout-spinner"></span>';
btn.style.opacity = '0.8';
btn.disabled = true;
}

if (form) {
const input = document.createElement('input');
input.type = 'hidden'; input.name = 'checkout'; input.value = 'Checkout';
form.appendChild(input);
form.submit();
}
};
});
